import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "knowledge-base-table";

const keys = addTranslations(RESOURCE_NAME, {
    no_results_found: {
        en: "No results found",
        fr: "Aucun résultat trouvé",
    },
    add_custom_item: {
        en: "Add custom item",
        fr: "Ajouter une information spécifique",
    },
    add_custom_item_instructions: {
        en: "Add a custom item to improve your AI suggestions",
        fr: "Ajoutez une information spécifique pour améliorer les suggestions de votre IA",
    },
    no_custom_items: {
        en: "No custom items",
        fr: "Aucune information spécifique",
    },
    add_custom_item_modal_title: {
        en: "Add custom item",
        fr: "Ajouter une information spécifique",
    },
    empty_state_title: {
        en: "No items found",
        fr: "Aucun élément trouvé",
    },
    empty_state_title_DOCUMENT: {
        en: "No documents found.",
        fr: "Aucun document trouvé.",
    },
    empty_state_title_INDICATOR: {
        en: "No indicators found.",
        fr: "Aucun indicateur trouvé.",
    },
    empty_state_title_OBJECTIVE: {
        en: "No objectives found.",
        fr: "Aucun objectif trouvé.",
    },
    empty_state_title_QUESTIONNAIRE: {
        en: "No questionnaires found.",
        fr: "Aucun questionnaire trouvé.",
    },
    empty_state_description: {
        en: "Please visit the page specific to the type of item you want to create.",
        fr: "Veuillez visiter la page spécifique au type d'élément que vous souhaitez créer.",
    },
    empty_state_description_DOCUMENT: {
        en: "Please visit the Policies, Measures or Custom Documents page to create one.",
        fr: "Veuillez visiter la page de Politiques, Mesures ou Documents spécifiques pour en créer un.",
    },
    empty_state_description_INDICATOR: {
        en: "Please visit the Reporting page to create an indicator.",
        fr: "Veuillez visiter la page de Reporting pour en créer un indicateur.",
    },
    empty_state_description_OBJECTIVE: {
        en: "Please visit the Objectives page to create an objective.",
        fr: "Veuillez visiter la page d'Objectifs pour en créer un objectif.",
    },
    empty_state_description_QUESTIONNAIRE: {
        en: "Please visit the Questionnaires page to create a questionnaire.",
        fr: "Veuillez visiter la page de Questionnaires pour en créer un questionnaire.",
    },
    visibility_status_disabled_tooltip: {
        en: "The status of this item cannot be changed",
        fr: "Le statut de cet élément ne peut pas être modifié",
    },
    visibility_status_disabled_tooltip_DOCUMENT: {
        en: "This document does not have any validated version",
        fr: "Ce document n'a pas de version validée",
    },
    visibility_status_disabled_tooltip_OBJECTIVE: {
        en: "This objective is not validated",
        fr: "Cette objectif n'est pas validé",
    },
    visibility_status_disabled_tooltip_QUESTIONNAIRE: {
        en: "This questionnaire does not have any validated answer",
        fr: "Ce questionnaire n'a pas de réponse validée",
    },
    visibility_status_disabled_tooltip_FRAMEWORK: {
        en: "This project does not have any validated question",
        fr: "Ce projet n'a pas de question validée",
    },
    updateKnowledge_base_success: {
        en: "Knowledge base item updated successfully",
        fr: "Base de connaissances mise à jour avec succès",
    },
    update_knowledge_base_error: {
        en: "Failed to update knowledge base item",
        fr: "Erreur lors de la mise à jour de la base de connaissances",
    },
    warning: {
        en: "",
        fr: "",
    },
    warning_DOCUMENT: {
        en: "Your AI is using a previously validated version of this document.",
        fr: "Votre IA utilise une version précédemment validée de ce document.",
    },
    warning_QUESTIONNAIRE: {
        en: "Your AI is using completed answers of this questionnaire only.",
        fr: "Votre IA utilise uniquement les réponses complétées de ce questionnaire.",
    },
});

export function useKnowledgeBaseTableTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
